import React from 'react';
import { FieldBehaviorMode } from '@app/queryTyping';
import { EmailFieldFragment } from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isEmailField } from '@app/common/configurable-wizards/utils';
import { EmailFieldComponent } from '@app/common/configurable-wizards/fields/email/EmailField';

/**
 * Reusing existing EmailFieldComponent, but displays it as Readonly for intermediate screen
 */
export const EmailField: FieldComponent<EmailFieldFragment> = ({
  parent,
  field,
  locator,
}) => {
  const emailField = { ...field, fieldBehaviorMode: FieldBehaviorMode.READONLY, label: '' };

  return (
    <EmailFieldComponent
      field={emailField}
      parent={parent}
      locator={locator}
    />
  );
};

export const DisplayEmailFieldLocator: FieldLocator = ({ field }) => (
  isEmailField(field)
    ? EmailField
    : undefined
);
